import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from 'ui-elements/button';
import { AccordionModule } from 'ui-elements/accordion';
import { FooterSection, FooterSectionLinks } from 'www-cms';
import { Store } from '@ngxs/store';
import { ShellState } from '../../shell.state';
import { tap } from 'rxjs';
import { ImageWithLoaderComponent } from '../../../building-blocks/components/image-with-loader/image-with-loader.component';
import { AmpersandLogoComponent } from '../ampersand-logo/ampersand-logo.component';

@Component({
  selector: 'ss-www-mobile-footer',
  imports: [
    CommonModule,
    AccordionModule,
    RouterModule,
    ButtonComponent,
    ImageWithLoaderComponent,
    AmpersandLogoComponent,
  ],
  templateUrl: './mobile-footer.component.html',
  styleUrls: ['./mobile-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileFooterComponent {
  mappedFooterContentSections$ = inject(Store)
    .select(ShellState.mappedFooterContentSections)
    .pipe(tap((mappedFooter) => this.mapPolicyLinks(mappedFooter)));
  dropdownSections = ['opportunities', 'shop', 'more'];
  infoSections = ['generalInquiries', 'lancaster', 'branson'];

  policyLinks: FooterSectionLinks[][] = [];
  year = new Date().getFullYear();
  socialLinks$ = inject(Store).select(ShellState.socialLinks);

  mapPolicyLinks(
    mappedFooterContentSections: Record<string, FooterSection> | undefined
  ) {
    if (!mappedFooterContentSections) {
      return;
    }
    const policyLinks = mappedFooterContentSections['mobilePolicyLinks'];

    this.policyLinks = this.chunkArray(policyLinks.footerSectionLinks, 3);
  }

  chunkArray<T>(array: T[], chunkSize: number): T[][] {
    let index = 0;
    let arrayLength = array.length;
    let tempArray = [];

    for (index = 0; index < arrayLength; index += chunkSize) {
      let chunk = array.slice(index, index + chunkSize);
      tempArray.push(chunk);
    }

    return tempArray;
  }
}
